<template>
    <div class="front-index" style="height: 100%;">
        <!-- 左侧边框栏 -->
        <frame class="page-frame"></frame>
        <!-- 左侧菜单栏 -->
        <menuList class="page-left"></menuList>
        
        <!-- 右侧内容主体 -->
        <div class="page-right">
            <div class="page-right-top">
                <div class="head">
                    <img class="avatar" ref="avatar" src='~@/assets/img/avatar.svg'>
                    <div>
                        欢迎您
                        <span class="user-name">{{ user.employeeName || user.account || '--' }}</span>
                    </div>
                    <img class="logout"  src="~@/assets/img/sign-out.svg" @click="jumpLogout()">
                    <div class='tip'>退出账号</div>

                </div>
            </div>
            <div class="main">
                <transition name="page">
                    <router-view></router-view>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import menuList from './index/menu.vue'
    import Frame from './Frame/frame.vue'
    export default {
        components: {
            menuList,
            Frame
        },

        computed:{
            user(){
                return this.$store.getters.userInfo;
            },
            avatar(){
                return this.user.headerUrl||'~@/assets/img/avatar.svg'
            }
        },

        created(){
        },
        mounted(){
            this.$store.dispatch('getUserInfo')
            .then(res=>{
                if(this.user.headerUrl==''){
                }else{
                    this.$refs.avatar.src=this.user.headerUrl
                }
            })
            
        },
        methods:{
            jumpLogout(){
                sessionStorage.clear()
                window.location.href = `${this.$url.eiisys_supplier}?action=logout`
            }
        }

    }
</script>

<style lang="less" scoped>
    .front-index{
        .clear();
        background:@g_background;
    }
    .page-left,.page-right{
        float:left;
    }
    .page-frame{
        float:left;
        height: 100%;
        width: 60px;
        background:rgba(23,33,45,1);
    }

    .page-right{
        width:calc(~"100% - 260px");
        height:100%;
        position:relative;
        .page-right-top{
            height: @g_head_h;
            z-index: 1;
            background: white;
            box-shadow:0px 2px 5px 0px rgba(0,0,0,0.05);
            font-size: 0;
            position: relative;

            .head{
                position:absolute;
                right:20px;
                top:50%;
                transform: translateY(-50%);
                font-size: 14px;
                height: 40px;
                line-height: 40px;
                vertical-align: middle;
                min-width: 160px;
                padding: 0 30px 0 50px;
                
                // 头像
                >.avatar{
                    position: absolute;
                    left:0;
                    height:40px;
                    width:40px;
                    border-radius: 50%;
                    background:#fff;
                    border:1px solid #CDD1D4;
                }

                .user-name{
                    color:@g_blue;
                    margin-right: 10px;
                }

                .logout{
                    position: absolute;
                    right: 5px;
                    top:50%;
                    transform: translateY(-50%);
                    cursor: pointer;
                    height: 20px;
                    width: 20px;
                    opacity: 0.6;
                    transition: 0.3s;
                    margin-bottom: -5px;
                    
                    &:hover{
                        opacity: 1;
                        &+.tip{
                            z-index: 1;
                            opacity: 1;
                        }
                    }
                }
                .tip{
                        pointer-events: none;
                        position: absolute;
                        // min-width:100px;
                        background: rgba(0, 0, 0, 0.7);
                        opacity: 0;
                        z-index:-1;
                        transition: 0.3s;
                        right: 0px;
                        top:100%;
                        color:#fff;
                        white-space: nowrap;
                        padding: 0 8px;
                        line-height: 28px;
                        border-radius:4px;
                    }
                
               
            }
        }

        .main {
            box-sizing: border-box;
            overflow: hidden;
            height:calc(~"100% - @{g_head_h}");
        }
    }

</style>
